import angular from 'angular';
import uiRouter from 'angular-ui-router';
import emailComponent from './email.component';
import emailListComponent from './email-list.component';
import emailDetailComponent from './email-detail.component';
import emailService from './email.service';

let emailModule = angular.module('email', [
  uiRouter
])

.service('Email', emailService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/email');

  $stateProvider
    .state('email', {
      component: 'email'
    })
    .state('email.list', {
      url: '/email',
      component: 'emailList'
    })
    .state('email.create', {
      url: '/email/new',
      component: 'emailDetail',
      params: {
      	id: ""
      }
    })
    .state('email.edit', {
      url: '/email/:id/edit',
      component: 'emailDetail',
      params: {
        id: ""
      }
    });
})

.component('email', emailComponent)
.component('emailList', emailListComponent)
.component('emailDetail', emailDetailComponent)

.name;

export default emailModule;



// WEBPACK FOOTER //
// ./client/app/components/email/email.js